import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useRouteMatch } from "../utils/RouteMatch";
import Reports from "./mobilitystore/sections/Reports";
import ReportPreview from "./mobilitystore/sections/ReportPreview";
import Printouts from "./mobilitystore/sections/Printouts";
import { useHasScope } from "../../../config/globalConfig";
import { MS_VIEW_PRINTOUTS, MS_VIEW_REPORTS } from "../utils/FinanceScope";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import { useRecoilState } from "recoil";
import { STATE_DISABLE_TAB } from "./mobilitystore/constants/MobilityStoreRecoil";

const PageMobilityStore = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'mobility-store' });
    const navigate = useNavigate();
    const location = useLocation();
    const hasScope = useHasScope;
    let ROUTING = [{ id: 2, name: t('tabs.printout-wizard'), pathname: '/finance/mobility-store/printouts-wizard', visible: false }];
    const [disableTab, setDisableTab] = useRecoilState(STATE_DISABLE_TAB);

    if (hasScope(MS_VIEW_REPORTS) && hasScope(MS_VIEW_PRINTOUTS)) {
        ROUTING = [
            { id: 0, name: t('tabs.report'), pathname: '/finance/mobility-store/', visible: true },
            { id: 1, name: t('tabs.printout'), pathname: '/finance/mobility-store/printouts', visible: true },
            { id: 2, name: t('tabs.printout-wizard'), pathname: '/finance/mobility-store/printouts-wizard', visible: false }
        ];
    } else if (hasScope(MS_VIEW_REPORTS)){
        ROUTING = [
            { id: 0, name: t('tabs.report'), pathname: '/finance/mobility-store/', visible: true },
        ];
    } else if (hasScope(MS_VIEW_PRINTOUTS)){
        ROUTING = [
            { id: 0, name: t('tabs.printout'), pathname: '/finance/mobility-store/printouts', visible: true },
            { id: 1, name: t('tabs.printout-wizard'), pathname: '/finance/mobility-store/printouts-wizard', visible: false }
        ];
    }

    const routeMatch = useRouteMatch(ROUTING.map(it => it.pathname));
    const currentTab = routeMatch?.pattern?.path;

    useEffect(() => {
        if (location.pathname === "/finance/mobility-store/report") {
            navigate("/finance/mobility-store");
        }
    })

    if (!hasScope(MS_VIEW_REPORTS) && !hasScope(MS_VIEW_PRINTOUTS)) return (<NotAuthorizedDialog />);

    return (
        <>
            <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')} />
            {!disableTab &&
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={currentTab ? currentTab : false}>
                    {ROUTING.filter(it => it.visible).map(it => <Tab key={it.id} label={it.name} value={it.pathname} to={it.pathname} component={Link} />)}
                </Tabs>
            </Box>
            }
            <Routes>
                {hasScope(MS_VIEW_REPORTS) && <Route path="/" element={<Reports />} />}
                {hasScope(MS_VIEW_REPORTS) && <Route path="/report/:id" element={<ReportPreview />} />}            
                {hasScope(MS_VIEW_PRINTOUTS) && <Route path="/printouts" element={<Printouts />} />}
            </Routes>
        </>
    );
}

export default PageMobilityStore;